import * as Immutable from "immutable";
import { Panel } from "./panel";

export class DocumentsPanel extends Panel {

}